import React from "react";

const DeliveryMetaCard = ({data}) => {
    return (
        <>
            <div className="card text-center">
                <div className="row">
                    <div className="col-4 text-center">
                        <div className="default-profile-img">
                        </div>
                    </div>
                    <div className="col-6 text-left">
                        <ul className="list-unstyled">
                            <li>{data.title}</li>
                            <li><small>{data.subTitle}</small></li>
                        </ul>
                    </div>
                    <div className="col-2 text-left align-middle">
                        <a href={"tel:" + data.subTitle}>
                            <i className="fas fa-phone"></i>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeliveryMetaCard;
